/**
 * @file Generated by js-routes 2.3.5. Based on Rails 8.0.5 routes of Activo::Application.
 * @version a7629dbf06a74a15ddfa9aaa65eeca4428dcc86189122aef2e0659a8f7048017
 * @see https://github.com/railsware/js-routes
 */
// eslint-disable-next-line
(typeof window !== 'undefined' ? window : this).Routes = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                if (module) {
                    module.exports = routes;
                }
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                if (define) {
                    define([], function () {
                        return routes;
                    });
                }
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using (typeof window !== 'undefined' ? window : this).Routes = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
        "script_name",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            let { trailing_slash, anchor, script_name } = keyword_parameters;
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            if (anchor) {
                result += "#" + anchor;
            }
            if (script_name) {
                const last_index = script_name.length - 1;
                if (script_name[last_index] == "/" && result[0] == "/") {
                    script_name = script_name.slice(0, last_index);
                }
                result = script_name + result;
            }
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            if (new_config.prefix) {
                console.warn("JsRoutes configuration prefix option is deprecated in favor of default_url_options.script_name.");
            }
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
            return module;
        }
    }
    const utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return utils.route(parts_table, route_spec, absolute);
        },
    };
    return utils.define_module("NIL", {
        ...__jsr,
        configure: (config) => {
            return utils.configure(config);
        },
        config: () => {
            return utils.config();
        },
        serialize: (object) => {
            return utils.serialize(object);
        },
        ...{
  /**
   * Generates rails route to
   * /about(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  about_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people/account(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  account_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"account"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /activity_locations/map/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  activity_location_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activity_locations"],[2,[7,"/"],[2,[6,"map"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles/activo(.:format)
   * @param {any} analytic_duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  activo_manage_analytic_articles_path: __jsr.r({"analytic_duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"activo"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/add_email(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_email_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"add_email"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/add_job_fee(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  add_job_fee_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"add_job_fee"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /after_volunteer_feedbacks(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  after_volunteer_feedbacks_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"after_volunteer_feedbacks"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts/:id/all_update(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  all_update_manage_all_contact_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"all_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /animal_protection(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  animal_protection_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"animal_protection"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /after_volunteer_feedbacks/answered(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  answered_after_volunteer_feedbacks_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"after_volunteer_feedbacks"],[2,[7,"/"],[2,[6,"answered"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /anywhere(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  anywhere_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"anywhere"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /api/v1/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/companies/:company_name/article_ids(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_company_article_ids_path: __jsr.r({"company_name":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"article_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/companies/:company_name/articles(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_company_articles_path: __jsr.r({"company_name":{"r":true},"format":{},"subdomain":{"d":"api"}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/companies/:company_name/topics/:id(.:format)
   * @param {any} company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_company_topic_path: __jsr.r({"company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/geo_suggests/:area_text(.:format)
   * @param {any} area_text
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_geo_suggest_path: __jsr.r({"area_text":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"geo_suggests"],[2,[7,"/"],[2,[3,"area_text"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/job/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_job_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/prefectures/:prefecture_id/cities(.:format)
   * @param {any} prefecture_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  api_v1_prefecture_cities_path: __jsr.r({"prefecture_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"prefectures"],[2,[7,"/"],[2,[3,"prefecture_id"],[2,[7,"/"],[2,[6,"cities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /articles/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  article_sp_preview_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/ad_managers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_ad_managers_path: __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"ad_managers"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/articles/related_contents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_articles_related_contents_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"related_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/base_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_base_data_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"base_data"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/bookmark(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_bookmark_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"bookmark"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/follow(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_follow_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/guide_for_company(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_guide_for_company_path: __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"guide_for_company"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/notification_mail_setting(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_notification_mail_setting_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"notification_mail_setting"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/reg_users/:reg_user_id/current_user(.:format)
   * @param {any} reg_user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_reg_user_current_user_path: __jsr.r({"reg_user_id":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[3,"reg_user_id"],[2,[7,"/"],[2,[6,"current_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/related_articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_related_articles_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"related_articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/related_stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_related_stories_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"related_stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/related_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_related_users_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"related_users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/search_histories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_search_histories_path: __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"search_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_stories_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/story_like(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_story_like_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"story_like"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/story_support(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_story_support_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"story_support"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/users/:user_id/articles(.:format)
   * @param {any} user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_user_articles_path: __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/users/:user_id/google_maps(.:format)
   * @param {any} user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_user_google_maps_path: __jsr.r({"user_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"google_maps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/user_presence_summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  async_info_user_presence_summary_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"user_presence_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /auth/louisvuitton_japan/callback(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  auth_louisvuitton_japan_callback_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"louisvuitton_japan"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limit_overrides/batch_create_or_update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  batch_create_or_update_manage_additional_entry_limit_overrides_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limit_overrides"],[2,[7,"/"],[2,[6,"batch_create_or_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /bookmark(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bookmark_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bookmark"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /articles/:id/bookmarks(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  bookmarks_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bookmarks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /column/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  column_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"column"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /column(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  columns_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"column"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /:search1(/:search2(/:search3))/kw/:word(.:format)
   * @param {any} search1
   * @param {any} word
   * @param {object | undefined} options
   * @returns {string} route path
   */
  combination_of_path_and_keyword_search_path: __jsr.r({"search1":{"r":true},"search2":{},"search3":{},"word":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"search1"],[2,[1,[2,[7,"/"],[2,[3,"search2"],[1,[2,[7,"/"],[3,"search3"]]]]]],[2,[7,"/"],[2,[6,"kw"],[2,[7,"/"],[2,[3,"word"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_path: __jsr.r({}, [7,"/"]),

  /**
   * Generates rails route to
   * /about(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_about_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /admin/*path(.:format)
   * @param {any} path
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_path: __jsr.r({"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[5,[3,"path"]],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/invitation/accept(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_accept_account_invitation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invitation"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/accounts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/invitation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_account_invitation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"invitation"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/accounts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_accounts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/approving_articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_approving_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"approving_articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/approving_articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_approving_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"approving_articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/blocking_users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_blocking_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blocking_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/blocking_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_blocking_users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"blocking_users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/bulk/approving_articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_bulk_approving_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"approving_articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_destroy_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/otp(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_new_otp_verification_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_new_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/notifications/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_notification_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_notifications_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/otp(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_otp_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/otp(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_otp_verification_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"otp"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/reg_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_reg_users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"reg_users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/otp/resend(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_resend_otp_verification_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"otp"],[2,[7,"/"],[2,[6,"resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_admin_top_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /apply/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_apply_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"apply"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /async_info/user_presence_summary(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_async_info_user_presence_summary_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"async_info"],[2,[7,"/"],[2,[6,"user_presence_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/auto_reply_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_auto_reply_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"auto_reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /bookmark(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_bookmark_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bookmark"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /complete/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /employees/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_destroy_employee_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /members/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_destroy_member_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_destroy_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/logout(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_destroy_user_session_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /employees/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_employee_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /employees(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_employees_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /employees/register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_employees_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /features/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_feature_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /features(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_features_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /followings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_followings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"followings"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_invite_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_all_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/contacts(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_article_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_edit_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_login_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_logout_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_templates_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/top(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_top_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"top"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_manage_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /members/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_member_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /members/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_member_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /members/register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_members_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /entry/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_new_contact_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_new_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /staff/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_new_staff_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/register(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_new_user_registration_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/login(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_new_user_session_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /notifications/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_notification_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /notifications(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_notifications_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notifications"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /pages/:file_name(.:format)
   * @param {any} file_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_page_path: __jsr.r({"file_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"file_name"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/pictures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_pictures_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /recent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_recent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recent"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/onboarding_task_events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_reg_user_onboarding_task_events_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"onboarding_task_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_register_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/reply_to_contact_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_reply_to_contact_templates_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reply_to_contact_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /search_histories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_search_histories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search_histories"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /searchresult(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_searchresult_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"searchresult"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /logged_out(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_sso_logged_out_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logged_out"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/sub_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_sub_tags_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sub_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /2025/summer_children(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_summer_children2025_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"2025"],[2,[7,"/"],[2,[6,"summer_children"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /topics/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_topic_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"topics"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:id(.:format)
   * @param {any} company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_article_path: __jsr.r({"company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:article_id/contacts(.:format)
   * @param {any} company_name
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_article_contacts_path: __jsr.r({"company_name":{"r":true},"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_article_index_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:article_id/preview_tokens/:id(.:format)
   * @param {any} company_name
   * @param {any} article_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_article_preview_token_path: __jsr.r({"company_name":{"r":true},"article_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview_tokens"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:article_id/preview_tokens(.:format)
   * @param {any} company_name
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_article_preview_tokens_path: __jsr.r({"company_name":{"r":true},"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/register(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_registration_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/login(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_user_session_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  company_users_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /after_volunteer_feedbacks/complete(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  complete_after_volunteer_feedbacks_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"after_volunteer_feedbacks"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails/confirm(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_for_group_entry/confirm(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_for_group_entry_index_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_for_group_entry"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_for_social_wednesday/confirm(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_for_social_wednesday_index_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_for_social_wednesday"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_of_customizable_mail_body/confirm(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  confirm_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_of_customizable_mail_body_index_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_of_customizable_mail_body"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /contact(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contact_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mail/contact_from_company(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  contact_from_company_mail_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[6,"contact_from_company"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mail/customer_service_from_form(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  customer_service_from_form_mail_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mail"],[2,[7,"/"],[2,[6,"customer_service_from_form"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /customer_stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  customer_stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_stories"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /customer_stories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  customer_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customer_stories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /articles/:id/bookmark(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  delete_bookmark_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bookmark"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/sign_out(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_person_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /logout(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  destroy_user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /detail_search_for_company/:company_name(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  detail_search_for_company_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"detail_search_for_company"],[2,[7,"/"],[2,[3,"company_name"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /for_developer/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  dev_user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"for_developer"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/accounts/:id/disable(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  disable_company_admin_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/accounts/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_admin_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/notifications/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_admin_notification_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /employees/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_employees_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"employees"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /members/password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_member_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:id/edit(.:format)
   * @param {any} company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_user_article_path: __jsr.r({"company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/edit(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_company_users_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:duration/edit(.:format)
   * @param {any} duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_analytic_path: __jsr.r({"duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"duration"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_analytics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_reg_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/supporter_acquire_settings/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_manage_supporter_acquire_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"supporter_acquire_settings"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/guide_contents/:id/edit(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_mp_admin_guide_content_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"guide_contents"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people_belonging_approvals/:token/edit(.:format)
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_people_belonging_approval_path: __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/people_belonging_approvals/:token/edit(.:format)
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_people_people_belonging_approval_path: __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[3,"token"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_person_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/password/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  edit_user_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/accounts/:id/enable(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  enable_company_admin_account_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /feed(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  feed_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"feed"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /for_company(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  for_company_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"for_company"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /for_company/pr_ads(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  for_company_pr_ads_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"for_company"],[2,[7,"/"],[2,[6,"pr_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /for_company/volunteer(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  for_company_volunteer_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"for_company"],[2,[7,"/"],[2,[6,"volunteer"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/form_editor(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  form_editor_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:id/form_editor(.:format)
   * @param {any} company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  form_editor_company_user_article_path: __jsr.r({"company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/form_editor(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  form_editor_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"form_editor"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /guides/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guide_content_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /guides(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  guide_contents_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"guides"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /healthcheck(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  healthcheck_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /intermediate_orgs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  intermediate_org_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"intermediate_orgs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /intermediate_orgs/:search1(.:format)
   * @param {any} search1
   * @param {object | undefined} options
   * @returns {string} route path
   */
  intermediate_org_search_path: __jsr.r({"search1":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"intermediate_orgs"],[2,[7,"/"],[2,[3,"search1"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /intermediate_orgs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  intermediate_orgs_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"intermediate_orgs"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /job(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /job/all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_all_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /job/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/articles/:id/preview(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_article_sp_preview_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/blank(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_blank_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"blank"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /job/complete/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/detail_search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_detail_search_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"detail_search"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /job/entry/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_new_contact_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_new_user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /job/searchresult(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_searchresult_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"searchresult"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /job/entry/:article_id/preview(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_sp_new_preview_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/u/:id/job(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_spread_reg_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"u"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"job"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id/job(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"job"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /job/register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  job_user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"job"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /kw/:word(.:format)
   * @param {any} word
   * @param {object | undefined} options
   * @returns {string} route path
   */
  keyword_search_path: __jsr.r({"word":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"kw"],[2,[7,"/"],[2,[3,"word"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:id/like(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  like_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"like"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:id/likes(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  likes_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"likes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mail_subscriptions/:token(.:format)
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mail_subscription_path: __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mail_subscriptions"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_users/:id/:path(.:format)
   * @param {any} id
   * @param {any} path
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_path: __jsr.r({"id":{"r":true},"path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"path"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limits/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limit_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limit_overrides/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limit_override_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limit_overrides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limit_overrides(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limit_overrides_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limit_overrides"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/additional_entry_limits(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_additional_entry_limits_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"additional_entry_limits"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_all_contact_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_all_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:duration(.:format)
   * @param {any} duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_path: __jsr.r({"duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"duration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles/:id(.:format)
   * @param {any} analytic_duration
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_article_path: __jsr.r({"analytic_duration":{"r":true},"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles/:article_id/type(.:format)
   * @param {any} analytic_duration
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_article_type_path: __jsr.r({"analytic_duration":{"r":true},"article_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/articles(.:format)
   * @param {any} analytic_duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_articles_path: __jsr.r({"analytic_duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/:analytic_duration/generals(.:format)
   * @param {any} analytic_duration
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytic_generals_path: __jsr.r({"analytic_duration":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[3,"analytic_duration"],[2,[7,"/"],[2,[6,"generals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/durations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytics_durations_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"durations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_analytics_users_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/additional_questions_duplicate(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_additional_questions_duplicate_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"additional_questions_duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/ads(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_ads_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"ads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/contacts(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/duplicate(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_duplicate_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/google_authorize(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_google_authorize_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"google_authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/preview_token/:id(.:format)
   * @param {any} article_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_preview_token_path: __jsr.r({"article_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview_token"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/preview_token(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_preview_tokens_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:article_id/tools(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_article_tools_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"tools"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/auto_reply_settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_auto_reply_setting_path: __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"auto_reply_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/auto_reply_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_auto_reply_settings_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"auto_reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/belonging_people(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_belonging_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"belonging_people"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/belonging_people/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_belonging_person_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"belonging_people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/bulk/ads_tickets(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_bulk_ads_tickets_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"ads_tickets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/bulk/ads_tickets/stripe_invoice(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_bulk_ads_tickets_stripe_invoice_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"ads_tickets"],[2,[7,"/"],[2,[6,"stripe_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/special_update/stripe_invoice(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_change_grade_special_update_stripe_invoice_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"special_update"],[2,[7,"/"],[2,[6,"stripe_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/stripe_subscription(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_change_grade_stripe_subscription_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"stripe_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/contacts/:id/contact_first_replies(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_contact_first_replies_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"contacts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"contact_first_replies"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/earned_scout_point_transactions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_earned_scout_point_transactions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"earned_scout_point_transactions"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/earned_scout_point_transactions/stripe_invoice(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_earned_scout_point_transactions_stripe_invoice_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"earned_scout_point_transactions"],[2,[7,"/"],[2,[6,"stripe_invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/edit(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_edit_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/google_authorize(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_google_authorize_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"google_authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/job_contract(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_job_contract_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"job_contract"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/job_posting_consent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_job_posting_consent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"job_posting_consent"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/oauth2callback(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_oauth2callback_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"oauth2callback"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/paid_plan_rules(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_paid_plan_rules_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"paid_plan_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/pictures(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_pictures_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"pictures"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/portal_connect(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_portal_connect_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"portal_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/billings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_billings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"billings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/onboarding_task_events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_onboarding_task_events_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"onboarding_task_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/user_page(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reg_user_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"user_page"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reply_to_contact_templates/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reply_to_contact_template_path: __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reply_to_contact_templates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reply_to_contact_templates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_reply_to_contact_templates_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reply_to_contact_templates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_message_rooms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_message_room_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_message_rooms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_message_rooms_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_message_rooms_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_message_rooms_bulk_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_message_rooms_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scout_policy(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scout_policy_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scout_policy"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/item_lists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_item_lists_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"item_lists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/members(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_members_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/scouts/scout_points(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_scouts_scout_points_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"scouts"],[2,[7,"/"],[2,[6,"scout_points"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/sheet_sync_info_of_contacts/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_sheet_sync_info_of_contact_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sheet_sync_info_of_contacts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/sheet_sync_info_of_contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_sheet_sync_info_of_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sheet_sync_info_of_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_stories_bulk_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/story_create(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_story_create_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"story_create"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/sub_tags(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_sub_tags_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"sub_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/supporter_acquire_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_supporter_acquire_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"supporter_acquire_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/toggle(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_toggle_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"toggle"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/top(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_top_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"top"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/update_card(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_update_card_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"update_card"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /manage/write_rule(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  manage_write_rule_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"write_rule"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/against_rules_articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_against_rules_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"against_rules_articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/against_rules_articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_against_rules_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"against_rules_articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/article_assessments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_article_assessment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"article_assessments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/articles/:article_id/bulk/assessment(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_article_bulk_assessment_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"assessment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/articles(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_articles_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/async_info(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_async_info_path: __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"async_info"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/bulk/article_assessment_save_events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_bulk_article_assessment_save_events_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"article_assessment_save_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/bulk/combinations_of_search_result_path_and_key_word(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_bulk_combinations_of_search_result_path_and_key_word_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"combinations_of_search_result_path_and_key_word"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/bulk/kw_search_result_routes_match_paths(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_bulk_kw_search_result_routes_match_paths_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"kw_search_result_routes_match_paths"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/bulk/search_key_words(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_bulk_search_key_words_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"search_key_words"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/buyer_company_applied_article_setting_infos(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_buyer_company_applied_article_setting_infos_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"buyer_company_applied_article_setting_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/deleted_free_trials/:email(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_deleted_free_trial_path: __jsr.r({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"deleted_free_trials"],[2,[7,"/"],[2,[3,"email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/expired_invoices(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_expired_invoices_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"expired_invoices"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/free_trials(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_free_trials_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"free_trials"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/guide_contents/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_guide_content_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"guide_contents"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/guide_contents(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_guide_contents_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"guide_contents"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/guide_contents_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_guide_contents_bulk_index_path: __jsr.r({"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"guide_contents_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/hourly_outbound(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_hourly_outbound_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"hourly_outbound"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/job_metrics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_job_metrics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"job_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/livesense_contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_livesense_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"livesense_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/mails_to_members(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_mails_to_members_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"mails_to_members"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/mails_to_members/count_members(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_mails_to_members_count_members_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"mails_to_members"],[2,[7,"/"],[2,[6,"count_members"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/mails_to_members/send_mail(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_mails_to_members_send_mail_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"mails_to_members"],[2,[7,"/"],[2,[6,"send_mail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/metrics(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_metrics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/metrics2(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_metrics2_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"metrics2"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/mypage(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_mypage_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"mypage"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/needing_article_assessment_reg_users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_needing_article_assessment_reg_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"needing_article_assessment_reg_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/needing_article_assessment_reg_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_needing_article_assessment_reg_users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"needing_article_assessment_reg_users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/outbound(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_outbound_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"outbound"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/penalty_for_unprofitable_jobs/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_penalty_for_unprofitable_job_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"penalty_for_unprofitable_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/penalty_for_unprofitable_jobs(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_penalty_for_unprofitable_jobs_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"penalty_for_unprofitable_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/picked_up_stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_picked_up_stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"picked_up_stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/profile_input_rates(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_profile_input_rates_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"profile_input_rates"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/pv_and_contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_pv_and_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"pv_and_contacts"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/recruiting_user_scraped_infos/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_recruiting_user_scraped_info_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"recruiting_user_scraped_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_user_assessments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_user_assessment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_user_assessments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users/:reg_user_id/assessment_save_events/:id(.:format)
   * @param {any} reg_user_id
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_user_assessment_save_event_path: __jsr.r({"reg_user_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[3,"reg_user_id"],[2,[7,"/"],[2,[6,"assessment_save_events"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users/:reg_user_id/bulk/assessment(.:format)
   * @param {any} reg_user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_user_bulk_assessment_path: __jsr.r({"reg_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[3,"reg_user_id"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"assessment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users/:reg_user_id/free_trials(.:format)
   * @param {any} reg_user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_user_free_trials_path: __jsr.r({"reg_user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[3,"reg_user_id"],[2,[7,"/"],[2,[6,"free_trials"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users/assessment_save_events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_users_assessment_save_events_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users"],[2,[7,"/"],[2,[6,"assessment_save_events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users_sorted_by_adoption_rate/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_users_sorted_by_adoption_rate_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users_sorted_by_adoption_rate"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users_sorted_by_adoption_rate(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_users_sorted_by_adoption_rate_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users_sorted_by_adoption_rate"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users_who_are_unaware_of_entries(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_users_who_are_unaware_of_entries_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users_who_are_unaware_of_entries"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users_who_are_unaware_of_entries/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_reg_users_who_are_unaware_of_entry_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users_who_are_unaware_of_entries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/scraped_recruitment_infos/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_scraped_recruitment_info_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"scraped_recruitment_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/scraped_recruitment_infos(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_scraped_recruitment_infos_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"scraped_recruitment_infos"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/search_categories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_search_categories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"search_categories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/search_result_paths(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_search_result_paths_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"search_result_paths"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/search_result_paths_displaying_guide(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_search_result_paths_displaying_guide_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"search_result_paths_displaying_guide"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/set_pick_up_stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_set_pick_up_stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"set_pick_up_stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/staff_found_fundraisings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_staff_found_fundraising_path: __jsr.r({"id":{"r":true},"format":{"d":"js"}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"staff_found_fundraisings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/staff_found_fundraisings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_staff_found_fundraisings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"staff_found_fundraisings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"stories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/stories_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_stories_bulk_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"stories_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/story_comments(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_story_comments_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"story_comments"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/story_comments_bulk(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_story_comments_bulk_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"story_comments_bulk"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/story_pick_ups/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_story_pick_up_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"story_pick_ups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/story_pick_ups(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_story_pick_ups_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"story_pick_ups"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/users_have_not_yet_contracted_for_job(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_users_have_not_yet_contracted_for_job_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"users_have_not_yet_contracted_for_job"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_companies_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/article_common_blacklists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_companies_article_common_blacklist_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[6,"article_common_blacklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/article_common_blacklists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_companies_article_common_blacklists_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[6,"article_common_blacklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/reg_user_common_blacklists/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_companies_reg_user_common_blacklist_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[6,"reg_user_common_blacklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/reg_user_common_blacklists(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_companies_reg_user_common_blacklists_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[6,"reg_user_common_blacklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:name(.:format)
   * @param {any} name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_path: __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/article_blacklists/:id(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_article_blacklist_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"article_blacklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/article_blacklists(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_article_blacklists_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"article_blacklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/articles(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_articles_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"articles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_for_group_entry(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_for_group_entry_index_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_for_group_entry"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_for_social_wednesday(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_for_social_wednesday_index_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_for_social_wednesday"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_of_customizable_mail_body(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_of_customizable_mail_body_index_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_of_customizable_mail_body"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/reg_user_blacklists/:id(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_reg_user_blacklist_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"reg_user_blacklists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/reg_user_blacklists(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mp_admin_volunteer_info_buyer_company_reg_user_blacklists_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"reg_user_blacklists"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/mypage(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  mypage_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"mypage"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /api/v1/stations/nearest(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  nearest_api_v1_stations_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"stations"],[2,[7,"/"],[2,[6,"nearest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /after_volunteer_feedbacks/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_after_volunteer_feedback_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"after_volunteer_feedbacks"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /admin/accounts/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_admin_account_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /admin/notifications/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_admin_notification_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"notifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_manage_article_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /members/password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_member_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/new(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_company_user_article_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_analytic_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/analytics/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_analytics_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_article_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/bulk/ads_tickets/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_bulk_ads_ticket_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"ads_tickets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/earned_scout_point_transactions/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_earned_scout_point_transaction_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"earned_scout_point_transactions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/job_posting_consent/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_job_posting_consent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"job_posting_consent"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/portal_connect/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_portal_connect_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"portal_connect"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/reg_user/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_reg_user_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"reg_user"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/stories/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_manage_story_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/bulk/combinations_of_search_result_path_and_key_word/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_bulk_combinations_of_search_result_path_and_key_word_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"combinations_of_search_result_path_and_key_word"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/bulk/search_key_words/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_bulk_search_key_word_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"search_key_words"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/free_trials/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_free_trial_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"free_trials"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/guide_contents/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_guide_content_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"guide_contents"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/penalty_for_unprofitable_jobs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_penalty_for_unprofitable_job_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"penalty_for_unprofitable_jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails/new(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mail_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_for_group_entry/new(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_for_group_entry_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_for_group_entry"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_for_social_wednesday/new(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_for_social_wednesday_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_for_social_wednesday"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/volunteer_info_buyer_companies/:volunteer_info_buyer_company_name/bulk/contact_staff_mails_of_customizable_mail_body/new(.:format)
   * @param {any} volunteer_info_buyer_company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_mp_admin_volunteer_info_buyer_company_bulk_contact_staff_mails_of_customizable_mail_body_path: __jsr.r({"volunteer_info_buyer_company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"volunteer_info_buyer_companies"],[2,[7,"/"],[2,[3,"volunteer_info_buyer_company_name"],[2,[7,"/"],[2,[6,"bulk"],[2,[7,"/"],[2,[6,"contact_staff_mails_of_customizable_mail_body"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people_belonging_approvals/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_people_belonging_approval_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people_belonging_approvals/:people_belonging_approval_token/people/new(.:format)
   * @param {any} people_belonging_approval_token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_people_belonging_approval_person_path: __jsr.r({"people_belonging_approval_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[3,"people_belonging_approval_token"],[2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_person_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /person_profile_onboarding/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_person_profile_onboarding_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_profile_onboarding"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/sign_up(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_person_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/sign_in(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_person_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sign_in_after_contact(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_person_sign_in_after_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in_after_contact"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_rails_conductor_inbound_email_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_rails_conductor_inbound_email_source_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /reg_user_session_handoffs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_reg_user_session_handoff_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reg_user_session_handoffs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /staff/login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_staff_saml_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /users/password/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  new_user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people_belonging_approvals/:token(.:format)
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_belonging_approval_path: __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people_belonging_approvals/:people_belonging_approval_token/people(.:format)
   * @param {any} people_belonging_approval_token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_belonging_approval_people_path: __jsr.r({"people_belonging_approval_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[3,"people_belonging_approval_token"],[2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people_belonging_approvals(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_belonging_approvals_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people_belonging_approvals"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people/contact_histories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_contact_histories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"contact_histories"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/follow(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_follow_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/items(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_items_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"items"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/people_belonging_approvals/:token(.:format)
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_people_belonging_approval_path: __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"people_belonging_approvals"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/postal_codes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_postal_codes_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"postal_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/replies(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_replies_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"replies"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/replies/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_reply_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/replies/:reply_id/events(.:format)
   * @param {any} reply_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_reply_events_path: __jsr.r({"reply_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"reply_id"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/scout_message_rooms/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_scout_message_room_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/scout_message_rooms(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_scout_message_rooms_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"scout_message_rooms"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/scout_messages(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_scout_messages_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"scout_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/search_results_notification_mail_settings/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_search_results_notification_mail_setting_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"search_results_notification_mail_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /people/search_results_notification_mail_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  people_search_results_notification_mail_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"search_results_notification_mail_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /person_profile_onboarding(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_profile_onboarding_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_profile_onboarding"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /person_profile_onboarding/recommendation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_profile_onboarding_recommendation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"person_profile_onboarding"],[2,[7,"/"],[2,[6,"recommendation"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people/sign_in(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sign_in_after_contacts(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  person_sign_in_after_contacts_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sign_in_after_contacts"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /picture_upload(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  picture_upload_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"picture_upload"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /plan_simulation(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  plan_simulation_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"plan_simulation"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /privacy_policy(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  privacy_policy_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /privacy_policy/access_data(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  privacy_policy_access_data_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy_policy"],[2,[7,"/"],[2,[6,"access_data"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /public/replies/:token(.:format)
   * @param {any} token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  public_reply_path: __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /public/replies/:reply_token/events(.:format)
   * @param {any} reply_token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  public_reply_events_path: __jsr.r({"reply_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"public"],[2,[7,"/"],[2,[6,"replies"],[2,[7,"/"],[2,[3,"reply_token"],[2,[7,"/"],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
   * @param {any} signed_blob_id
   * @param {any} variation_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_blob_representation_path: __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
   * @param {any} signed_blob_id
   * @param {any} variation_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_blob_representation_proxy_path: __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
   * @param {any} inbound_email_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_incinerate_path: __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
   * @param {any} inbound_email_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_reroute_path: __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_email_sources_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/conductor/action_mailbox/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_conductor_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/direct_uploads(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_direct_uploads_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/disk/:encoded_key/*filename(.:format)
   * @param {any} encoded_key
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_disk_service_path: __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/info(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_info_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /rails/info/notes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_info_notes_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"notes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/info/properties(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_info_properties_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/info/routes(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_info_routes_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/mailers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mailers_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mailgun_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mandrill/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mandrill_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/mandrill/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_mandrill_inbound_health_check_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/postmark/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_postmark_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/relay/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_relay_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_sendgrid_inbound_emails_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
   * @param {any} signed_id
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_service_blob_path: __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
   * @param {any} signed_id
   * @param {any} filename
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rails_service_blob_proxy_path: __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /recent(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recent_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recent"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /recruitment_infos/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  recruitment_info_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"recruitment_infos"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /people/contact_histories/:id/redirect_to_article(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  redirect_to_article_people_contact_history_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"contact_histories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"redirect_to_article"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/reply_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reply_settings_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/articles/:id/reply_settings(.:format)
   * @param {any} company_name
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reply_settings_company_user_article_path: __jsr.r({"company_name":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/reply_settings(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  reply_settings_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reply_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/deleted_free_trials/:email/restore(.:format)
   * @param {any} email
   * @param {object | undefined} options
   * @returns {string} route path
   */
  restore_mp_admin_deleted_free_trial_path: __jsr.r({"email":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"deleted_free_trials"],[2,[7,"/"],[2,[3,"email"],[2,[7,"/"],[2,[6,"restore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /
   * @param {object | undefined} options
   * @returns {string} route path
   */
  root_path: __jsr.r({}, [7,"/"]),

  /**
   * Generates rails route to
   * /rules(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  rules_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /:search1(/:search2(/:search3))(.:format)
   * @param {any} search1
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_path: __jsr.r({"search1":{"r":true},"search2":{},"search3":{},"format":{}}, [2,[7,"/"],[2,[3,"search1"],[2,[1,[2,[7,"/"],[2,[3,"search2"],[1,[2,[7,"/"],[3,"search3"]]]]]],[1,[2,[8,"."],[3,"format"]]]]]]),

  /**
   * Generates rails route to
   * /search_for_company/:company_name(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_for_company_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"search_for_company"],[2,[7,"/"],[2,[3,"company_name"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /search_results_notification_mail_settings(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  search_results_notification_mail_settings_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search_results_notification_mail_settings"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people/setting(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  setting_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"setting"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /sidekiq
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sidekiq_web_path: __jsr.r({}, [2,[7,"/"],[6,"sidekiq"]]),

  /**
   * Generates rails route to
   * /site-map(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  site_map_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"site-map"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /2025/summer_children(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  social_wednesday_summer_children2025_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"2025"],[2,[7,"/"],[2,[6,"summer_children"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /terms_and_conditions(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  social_wednesday_terms_and_conditions_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms_and_conditions"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /manage/change_grade/special_update(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  special_update_manage_change_grade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"change_grade"],[2,[7,"/"],[2,[6,"special_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/a/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  spread_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /spread/companies/staff_session_checks(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  spread_companies_staff_session_checks_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"spread"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"staff_session_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/complete/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  spread_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/e/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  spread_new_contact_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"e"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/u/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  spread_reg_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"u"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /staff/saml/auth(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  staff_saml_auth_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /staff/saml/metadata(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  staff_saml_metadata_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"staff"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /staff_session_handoffs/new(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  staff_session_handoff_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"staff_session_handoffs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /stories(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stories_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stories"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /stories/hash_tags/:name(.:format)
   * @param {any} name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stories_hash_tag_path: __jsr.r({"name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[6,"hash_tags"],[2,[7,"/"],[2,[3,"name"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /story_comments/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  story_comment_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"story_comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /story_comments/:story_comment_id/comments(.:format)
   * @param {any} story_comment_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  story_comment_comments_path: __jsr.r({"story_comment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"story_comments"],[2,[7,"/"],[2,[3,"story_comment_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:story_id/comments(.:format)
   * @param {any} story_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  story_comments_path: __jsr.r({"story_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"story_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /hooks/stripe
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stripe_path: __jsr.r({}, [2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[6,"stripe"]]]]),

  /**
   * Generates rails route to
   * /hooks/stripe/events(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  stripe_events_path: __jsr.r({"format":{}}, [2,[2,[2,[7,"/"],[2,[6,"hooks"],[2,[7,"/"],[6,"stripe"]]]],[7,"/"]],[2,[6,"events"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /sub_search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  sub_search_index_path: __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"sub_search"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /2025/summer_children(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  summer_children2025_index_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"2025"],[2,[7,"/"],[2,[6,"summer_children"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /stories/:id/supports(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  supports_story_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"stories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"supports"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /manage/articles/:id/templates(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  templates_company_manage_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"manage"],[2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"templates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /10th(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tenth_anniversary_landing_page_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"10th"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /10th/organizations(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tenth_anniversary_organizations_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"10th"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /10th/volunteers(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  tenth_anniversary_volunteers_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"10th"],[2,[7,"/"],[2,[6,"volunteers"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /companies/:company_name/users/top(.:format)
   * @param {any} company_name
   * @param {object | undefined} options
   * @returns {string} route path
   */
  top_company_users_path: __jsr.r({"company_name":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_name"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"top"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /trade(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  trade_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"trade"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /recede_historical_location(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  turbo_recede_historical_location_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recede_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /refresh_historical_location(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  turbo_refresh_historical_location_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"refresh_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /resume_historical_location(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  turbo_resume_historical_location_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resume_historical_location"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /mp_admin/reg_users_who_are_unaware_of_entries/:id/update_last_followed_bounce_mail_by_staff_at(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_last_followed_bounce_mail_by_staff_at_mp_admin_reg_users_who_are_unaware_of_entry_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mp_admin"],[2,[7,"/"],[2,[6,"reg_users_who_are_unaware_of_entries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_last_followed_bounce_mail_by_staff_at"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /rails/active_storage/disk/:encoded_token(.:format)
   * @param {any} encoded_token
   * @param {object | undefined} options
   * @returns {string} route path
   */
  update_rails_disk_service_path: __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /user_attributes_survey(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_attributes_survey_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user_attributes_survey"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users/:user_id/follow(.:format)
   * @param {any} user_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_follow_path: __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /users/password(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_password_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /register(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_registration_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users/:search1(/:search2)(.:format)
   * @param {any} search1
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_search_path: __jsr.r({"search1":{"r":true},"search2":{},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"search1"],[2,[1,[2,[7,"/"],[3,"search2"]]],[1,[2,[8,"."],[3,"format"]]]]]]]]),

  /**
   * Generates rails route to
   * /login(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  user_session_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  users_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /all(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_all_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"all"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /articles/:id(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_article_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"articles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /complete/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_contacts_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"complete"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /detail_search(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_detail_search_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"detail_search"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /entry/:article_id(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_new_contact_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[1,[2,[8,"."],[3,"format"]]]]]]]),

  /**
   * Generates rails route to
   * /searchresult(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_searchresult_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"searchresult"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /entry/:article_id/preview(.:format)
   * @param {any} article_id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_sp_new_preview_path: __jsr.r({"article_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"entry"],[2,[7,"/"],[2,[3,"article_id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /s/u/:id/volunteer(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_spread_reg_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[6,"u"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"volunteer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]),

  /**
   * Generates rails route to
   * /volunteer_survey(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_survey_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"volunteer_survey"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /users/:id/volunteer(.:format)
   * @param {any} id
   * @param {object | undefined} options
   * @returns {string} route path
   */
  volunteer_user_path: __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"volunteer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]),

  /**
   * Generates rails route to
   * /vote(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  vote_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"vote"],[1,[2,[8,"."],[3,"format"]]]]]),

  /**
   * Generates rails route to
   * /people/withdrawal(.:format)
   * @param {object | undefined} options
   * @returns {string} route path
   */
  withdrawal_people_path: __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"people"],[2,[7,"/"],[2,[6,"withdrawal"],[1,[2,[8,"."],[3,"format"]]]]]]])}
,
    });
})();
